// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWeekScheduleIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M19 4h-2V3c0-.55-.45-1-1-1s-1 .45-1 1v1H9V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2M5 19V9h14v10zm4-7c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m2 0c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1m-6 4c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1" />
  </g>
);
export default SvgWeekScheduleIcon;
SvgWeekScheduleIcon.displayName = 'SvgWeekScheduleIcon';
